function Fields(el) {
	var formSelects = Array.prototype.slice.call(el.querySelectorAll('.ginput_container_select'));
	if ( formSelects ) {
		// Create markup for select
		formSelects.forEach(function(elem) {
			var formNativeSelect = elem.querySelector('select'),
				formOptionsSelect = formNativeSelect.querySelectorAll('option'),
				formPlaceholder = formNativeSelect.getAttribute('data-placeholder'),
				formListSelect,
				markupSelect,
				placeholderField = '';
			formNativeSelect.setAttribute('data-field-mobile', '');
			formListSelect = '<div class="select-field__desktop"><ul class="h6 c-secondary-brand select-field__dropdown" data-field-desktop>';
			for (var i = 0; i < formOptionsSelect.length; i++) {
				formListSelect += '<li class="select-field__dropdown-item" data-value="' +
					formOptionsSelect[i].getAttribute('value') + '">' +
					formOptionsSelect[i].innerHTML + '</li>';
			}
			formListSelect += '</ul></div><span class="select-field__arrow"></span>';
			if( formPlaceholder ) {
				placeholderField = '<span class="select-field__placeholder">' + formPlaceholder + '</span>';
			}
			markupSelect = '<div class="h6 c-secondary-brand select-field__current" data-field-current>' + placeholderField + '</div><div class="select-field__mobile">' +
				formNativeSelect.outerHTML + '</div>' + formListSelect;
			elem.innerHTML = markupSelect;

			// Select first item
			var current = el.querySelector('[data-field-current]'),
					mobile = el.querySelector('[data-field-mobile]'),
					desktop = el.querySelector('[data-field-desktop]');

			current.innerHTML = mobile.querySelector('option').innerHTML;
			mobile.selectedIndex = 0;
		});
	}
}

module.exports = Fields;
